import { render, staticRenderFns } from "./RecordingPanel.vue?vue&type=template&id=9683b5e0&scoped=true"
import script from "./RecordingPanel.vue?vue&type=script&lang=js"
export * from "./RecordingPanel.vue?vue&type=script&lang=js"
import style0 from "./RecordingPanel.vue?vue&type=style&index=0&id=9683b5e0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9683b5e0",
  null
  
)

export default component.exports